import { config } from "@lisapet/config";
import { createApi } from "@reduxjs/toolkit/query/react";
import {
  type CheckoutEventsData,
  type CheckoutOpenOptions,
  initializePaddle,
} from "@paddle/paddle-js";
import { serializeError } from "serialize-error";
import { supabaseBaseQuery } from "../../../supabase";

const paymentsApi = createApi({
  reducerPath: "api.PaymentsApi",
  baseQuery: supabaseBaseQuery,
  endpoints: (builder) => ({
    initiateCheckout: builder.mutation<CheckoutEventsData, CheckoutOpenOptions>({
      queryFn: async (options) => {
        try {
          const checkoutEventData = await new Promise<CheckoutEventsData>(
            // eslint-disable-next-line no-async-promise-executor
            async (resolve) => {
              const paddle = await initializePaddle({
                token: config.paddle.token,
                environment: config.paddle.env,
                checkout: {
                  settings: {
                    theme: "light",
                    variant: "one-page",
                  },
                },
                eventCallback: (event) => {
                  switch (event.name) {
                    case "checkout.completed":
                      resolve(event.data!);
                      break;
                  }
                },
              });

              if (!paddle) {
                throw new Error("Paddle not initialized");
              }

              paddle.Checkout.open(options);
            },
          );

          return { data: checkoutEventData };
        } catch (error) {
          return { error: serializeError(error as Error) };
        }
      },
    }),
  }),
});

const { useInitiateCheckoutMutation } = paymentsApi;

export { useInitiateCheckoutMutation, paymentsApi };
